const scope = process.env.VUE_APP_SESSION_SCOPE || 'online-v1'
const entryModeKey = `cloudphone:h5:${scope}:entry-mode`

export function prefersWebEntry() {
  return localStorage.getItem(entryModeKey) === 'web'
}

export function rememberWebEntry() {
  localStorage.setItem(entryModeKey, 'web')
}

export function clearWebEntryPreference() {
  localStorage.removeItem(entryModeKey)
}
